import React, { useMemo } from 'react';
import { Route } from 'react-router-dom';
import type { RouteProps } from 'react-router-dom';
import { withLogin, withLoginRequest } from '../hooks';

export const UserRoute = (
   props: RouteProps & {
      withModal?: boolean;
      title?: string;
      description?: string;
   },
) => {
   const { withModal, title, description, component, children, render, ...routeProps } = props;

   const realComponent = useMemo(() => {
      if (component) return component;
      if (render) return render;
      if (children) return <>{children}</>;
   }, [component, children, render]) as React.ComponentType;

   const componentLogged = useMemo(() => {
      return withModal ? withLoginRequest(realComponent, { title, description }) : withLogin(realComponent);
   }, [realComponent, withModal, title, description]);

   return <Route {...routeProps} component={componentLogged} />;
};
